module.exports = __webpack_public_path__ + "static/img/shilard.7400c79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/shilard.png
// module id = Yifv
// module chunks = 0